import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/img/icon/filter-1.svg';
import _imports_1 from '@/img/icon/filter-2.svg';
import _imports_2 from '@/img/icon/filter-3.svg';
import _imports_3 from '@/img/icon/plus.svg';
const _withScopeId = n => (_pushScopeId("data-v-0571877a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "product"
};
const _hoisted_2 = {
  class: "product__wrapperimg"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "product__filters"
};
const _hoisted_5 = {
  key: 0,
  class: "product__filters-item"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product__filters-img",
  src: _imports_0,
  alt: "filter"
}, null, -1));
const _hoisted_7 = [_hoisted_6];
const _hoisted_8 = {
  key: 1,
  class: "product__filters-item"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product__filters-img",
  src: _imports_1,
  alt: "filter"
}, null, -1));
const _hoisted_10 = [_hoisted_9];
const _hoisted_11 = {
  key: 2,
  class: "product__filters-item"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product__filters-img",
  src: _imports_2,
  alt: "filter"
}, null, -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = {
  class: "product__title"
};
const _hoisted_15 = {
  key: 0,
  class: "product__weight"
};
const _hoisted_16 = {
  key: 1,
  class: "product__weight"
};
const _hoisted_17 = {
  class: "product__text"
};
const _hoisted_18 = {
  class: "product__price"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_20 = {
  class: "product__tags"
};
const _hoisted_21 = {
  key: 0,
  class: "product__tag product-hit"
};
const _hoisted_22 = {
  key: 1,
  class: "product__tag product-new"
};
const _hoisted_23 = {
  class: "product-btns"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "product__cart-img",
  src: _imports_3,
  alt: "cart"
}, null, -1));
const _hoisted_26 = [_hoisted_25];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "product-link",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push(`/rol-shop/${$props.category}/${$props.id}`))
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("img", {
    class: "product__img",
    src: require(`@/img/products/${$props.imgUrl}`),
    alt: "product"
  }, null, 8, _hoisted_3), _createElementVNode("div", _hoisted_4, [$props.filter_1 ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7)) : _createCommentVNode("", true), $props.filter_2 ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)) : _createCommentVNode("", true), $props.filter_3 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13)) : _createCommentVNode("", true)])]), _createElementVNode("h6", _hoisted_14, _toDisplayString($props.title), 1), $props.weight ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Вес: " + _toDisplayString($props.weight) + " г", 1)) : (_openBlock(), _createElementBlock("p", _hoisted_16, "Объем: " + _toDisplayString($props.volume) + " л", 1)), _createElementVNode("p", _hoisted_17, _toDisplayString($props.composition), 1), _createElementVNode("p", _hoisted_18, [_createTextVNode(_toDisplayString($props.price), 1), _hoisted_19]), _createElementVNode("div", _hoisted_20, [$props.isHit ? (_openBlock(), _createElementBlock("div", _hoisted_21, "Hit")) : _createCommentVNode("", true), $props.isNew ? (_openBlock(), _createElementBlock("div", _hoisted_22, "New")) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_23, [_createElementVNode("button", {
    class: _normalizeClass(["product__favorite", {
      'is-favorite': $props.isFavorite
    }]),
    onClick: _cache[1] || (_cache[1] = (...args) => $props.onClickFavorite && $props.onClickFavorite(...args))
  }, [_createElementVNode("img", {
    class: "product__favorite-img",
    src: !$props.isFavorite ? require('@/img/icon/favorite.svg') : require('@/img/icon/favorite-checked.svg'),
    alt: "heart"
  }, null, 8, _hoisted_24)], 2), _createElementVNode("button", {
    class: _normalizeClass(["product__cart", {
      'is-added': $props.isAdded
    }]),
    onClick: _cache[2] || (_cache[2] = (...args) => $props.onClickAdd && $props.onClickAdd(...args))
  }, _hoisted_26, 2)])]);
}